import { useState, useEffect, useRef, useCallback } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';

export const BreadcrumbContainer = ({ pathname, link, homeLink }) => {
    const navigate = useNavigate();
    const previusLink = useRef(true);
    const pathMemory = useRef('');

    const [pathTot, setPathTot] = useState([]);
    const pathTotRef = useRef([]);
    useEffect(() => {
        pathTotRef.current = pathTot;
    }, [pathTot]);

    const handleClick = useCallback(
        (linkName, type, event) => {
            if (event) {
                if (
                    event.target.id ===
                    pathMemory.current[pathMemory.current.length - 1].props.id
                ) {
                    return;
                } else {
                    navigate(linkName);
                }
            } else {
                if (type === 'back') {
                    //se è una pagina dettaglio torno indietro
                    navigate(linkName);
                } else {
                    navigate(`${linkName}`);
                }
            }
        },
        [navigate]
    );

    useEffect(() => {
        pathMemory.current = pathTot;
    }, [pathTot]);

    useEffect(() => {
        (() => {
            let pathHistory = [...pathTotRef.current];
            //se eseguono un refresh forzo l'aggiunta di Home come primo elemento dell'array
            if (pathHistory.length === 0) {
                pathHistory.push(
                    <Link
                        component="button"
                        id="Dashboard"
                        key={1}
                        color="inherit"
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            textDecoration: 'none',
                        }}
                        onClick={() =>
                            handleClick(
                                homeLink ? homeLink : '/AreaClienti/Dashboard'
                            )
                        }
                        className="text-underline-hover"
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Home
                    </Link>
                );
            }
            for (let i = 0; i < pathHistory.length; i++) {
                //se non è "dettaglio" elimino lo sotrico dopo Home
                if (!pathname.includes('dettaglio')) {
                    pathHistory = pathHistory.slice(0, 1);
                }
                //se esiste già nella Breadcrumb torno indietro e elimino lo storico
                if (pathHistory[i].props.id === pathname) {
                    pathHistory = pathHistory.slice(0, i + 1);
                    previusLink.current = false;
                }
            }
            if (previusLink.current) {
                if (pathname === 'Dashboard') {
                    pathHistory.push(
                        <Link
                            component="button"
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            onClick={() =>
                                handleClick('/AreaClienti/Dashboard')
                            }
                            className="text-underline-hover"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            {pathname}
                        </Link>
                    );
                } else if (pathname.includes('dettaglio')) {
                    pathHistory.push(
                        <Link
                            component="button"
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            onClick={(e) => handleClick(-1, 'back', e)}
                            className="text-underline-hover"
                        >
                            {link}
                        </Link>
                    );
                } else if (pathname === '') {
                    return;
                } else {
                    pathHistory.push(
                        <Link
                            component="button"
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            onClick={() => handleClick(pathname)}
                            className="text-underline-hover"
                        >
                            {pathname}
                        </Link>
                    );
                }
            }
            setPathTot(pathHistory);
            previusLink.current = true;
        })();
    }, [pathname, link, homeLink, handleClick]); //tutte le volte che cambia il pathname viene eseguito
    return (
        <>
            <Stack spacing={2} marginLeft={2} className="z-10 hidden md:block">
                <Breadcrumbs
                    sx={{ overflow: 'hidden' }}
                    className="containerBreadcrumbs"
                    separator={
                        <NavigateNextIcon
                            fontSize="small"
                            className="dark:text-white"
                        />
                    }
                    aria-label="breadcrumb"
                >
                    {pathTot}
                </Breadcrumbs>
            </Stack>
        </>
    );
};
